/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CaptureFeed from './CaptureFeed/index'
import DeviceChooser from './DeviceChooser/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content",
  preview,
  handleClear,
  innerRef,
  theme,
  handleClick,
  showOverlay
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<DeviceChooser
  viewPath={`${viewPath}/DeviceChooser`}
 preview={preview}
 handleClear={handleClear}
/>
<CaptureFeed
  viewPath={`${viewPath}/CaptureFeed`}
 preview={preview}
 innerRef={innerRef}
 theme={theme}
 handleClick={handleClick}
 showOverlay={showOverlay}
/>
</div>
{children}
</React.Fragment>)
}